import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Pipe, NgModule } from '@angular/core';
import * as i1 from '@angular/platform-browser';
import * as DOMPurify from 'dompurify';

class DomPurifyService {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    sanitizeHtml(html, config) {
        const sanitized = DOMPurify.sanitize(html, config);
        return this.sanitizer.bypassSecurityTrustHtml(sanitized);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DomPurifyService, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DomPurifyService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DomPurifyService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; } });

class EscapeHtmlPipe {
    constructor(domPurifyService) {
        this.domPurifyService = domPurifyService;
    }
    transform(content, config) {
        return this.domPurifyService.sanitizeHtml(content, config);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EscapeHtmlPipe, deps: [{ token: DomPurifyService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: EscapeHtmlPipe, name: "escapeHtml" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EscapeHtmlPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'escapeHtml', pure: true }]
        }], ctorParameters: function () { return [{ type: DomPurifyService }]; } });

class DomService {
    scrollTo(x = 0, y = 0) {
        if (window['scrollTo']) {
            window.scrollTo({
                top: x,
                left: y,
                behavior: 'smooth'
            });
        }
        else {
            console.warn('No scroll support');
        }
    }
    scrollToTop() {
        this.scrollTo(0, 0);
    }
    lookForStylesheets(names) {
        const linkTags = Array.prototype.slice
            .call(document.getElementsByTagName('link'));
        const linkHrefs = linkTags.map((linkTag) => linkTag.href);
        let stylesheets = [];
        names.forEach((name) => {
            const potentials = linkHrefs.filter((href) => {
                const fileName = href.split('/').pop();
                return fileName.startsWith(name + '.') && fileName.endsWith('.css');
            });
            stylesheets = stylesheets.concat(potentials);
        });
        return stylesheets;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DomService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DomService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DomService, decorators: [{
            type: Injectable
        }] });

class DomModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DomModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DomModule, declarations: [EscapeHtmlPipe], imports: [CommonModule], exports: [EscapeHtmlPipe] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DomModule, providers: [
            DomPurifyService,
            DomService
        ], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DomModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    providers: [
                        DomPurifyService,
                        DomService
                    ],
                    declarations: [
                        EscapeHtmlPipe
                    ],
                    exports: [
                        EscapeHtmlPipe
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DomModule, DomPurifyService, DomService, EscapeHtmlPipe };
